export default __webpack_public_path__ + "402ff14a5343eb49cab00472c18f186d.png";